import type { AppRole } from './AuthSessionProvider';

export interface ProfilePermissionViewer {
	isAuthenticated: boolean;
	role: AppRole | string | null;
	email?: string | null;
	idInvestigador?: number | null;
	unitId?: string | null;
	macroUnitId?: string | null;
}

export interface ProfilePermissionTarget {
	slug: string;
	email?: string | null;
	idInvestigador?: number | null;
	unitId?: string | null;
	macroUnitId?: string | null;
}

export interface InvestigatorProfilePermissions {
	canSuggestChanges: boolean;
	canEditDirectly: boolean;
	action: 'none' | 'suggest' | 'edit';
}

export function resolveInvestigatorProfilePermissions({
	viewer,
	target,
}: {
	viewer: ProfilePermissionViewer;
	target: ProfilePermissionTarget;
}): InvestigatorProfilePermissions {
	if (!viewer.isAuthenticated) {
		return { canSuggestChanges: false, canEditDirectly: false, action: 'none' };
	}

	if (viewer.role === 'admin') {
		return { canSuggestChanges: false, canEditDirectly: true, action: 'edit' };
	}

	if (viewer.role === 'investigador') {
		// Ownership is determined exclusively by idInvestigador FK.
		// Email fallback has been removed: idInvestigador is now guaranteed in every
		// ownership path (auth/me returns it; adaptInvestigadorPublicProfile maps it).
		const isOwnProfile = Boolean(
			viewer.idInvestigador != null && target.idInvestigador != null && viewer.idInvestigador === target.idInvestigador,
		);

		return {
			canSuggestChanges: isOwnProfile,
			canEditDirectly: false,
			action: isOwnProfile ? 'suggest' : 'none',
		};
	}

	if (viewer.role === 'editor') {
		const sameUnit = Boolean(viewer.unitId && target.unitId && viewer.unitId === target.unitId);
		const sameMacroUnit = Boolean(
			viewer.macroUnitId && target.macroUnitId && viewer.macroUnitId === target.macroUnitId,
		);

		// TODO: rbac - definición final negocio para alcance editor por macrounidad.
		const canSuggest = sameUnit || sameMacroUnit;

		return {
			canSuggestChanges: canSuggest,
			canEditDirectly: false,
			action: canSuggest ? 'suggest' : 'none',
		};
	}

	return { canSuggestChanges: false, canEditDirectly: false, action: 'none' };
}
